import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';
import classNames from 'classnames';

import MapListHeader from 'bundles/research/index/components/map_list_header';
import MapListItem from 'bundles/research/index/components/map_list_item';
import SelectionDetails from 'components/selection_details';
import { selectPropertyMarker } from '../store/actions/ui';
import {
  resetSelectedProperties,
  toggleSelectProperty,
  toggleSelectAllPropertiesOnCurrentPage,
  toggleSelectAllProperties,
} from '../store/actions/select_list';

import { goToPropertyShow } from '../store/actions/properties';
import 'styles/semantic-ui-placeholder.scss';
import { debounce, times } from 'lodash';

export class PropertiesMapList extends React.Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    edgeCrm: PropTypes.bool,
    googleMapsApiKey: PropTypes.string,
    goToPropertyShow: PropTypes.func.isRequired,
    isFetchingProperties: PropTypes.bool,
    properties: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
      })
    ).isRequired,
    propertyIds: PropTypes.array.isRequired,
    resetSelection: PropTypes.func.isRequired,
    selectedPropertyIds: PropTypes.array.isRequired,
    showMapList: PropTypes.bool.isRequired,
    toggleSelectAll: PropTypes.func.isRequired,
    toggleSelectAllPropertiesOnCurrentPage: PropTypes.func.isRequired,
    toggleSelectProperty: PropTypes.func.isRequired,
    totalCount: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onPropertyHover: PropTypes.func.isRequired,
  };

  throttledHover = debounce(this.props.onPropertyHover, 250);

  render() {
    const {
      isFetchingProperties,
      properties,
      selectedPropertyIds,
      toggleSelectAllPropertiesOnCurrentPage,
    } = this.props;

    const allPropertiesSelected =
      selectedPropertyIds.length >= properties.length && properties.length > 0;
    return (
      <div className="bg-body border-end d-flex flex-column h-100">
        <MapListHeader
          allSelected={allPropertiesSelected}
          edgeCrm={this.props.edgeCrm}
          selectionCount={selectedPropertyIds.length}
          toggleSelectAll={toggleSelectAllPropertiesOnCurrentPage}
          totalCount={properties.length}
          totalLabel="property"
        />
        <div className="flex-grow-1 overflow-y-auto">
          {isFetchingProperties
            ? this.renderPlaceholder()
            : this.renderProperties()}
        </div>
      </div>
    );
  }

  renderPlaceholder() {
    const placeholders = times(8, i => (
      <div className="card" key={`placeholder-${i}`}>
        <div className="card-body">
          <div className="d-flex flex-column gap-1">
            <div className="placeholder rounded" />
            <div className="placeholder rounded w-75" />
            <div className="placeholder rounded w-50" />
          </div>
        </div>
      </div>
    ));

    return (
      <div className="d-flex flex-column gap-3 p-3">
        <h6 className="text-muted">Loading properties...</h6>
        {placeholders}
      </div>
    );
  }

  renderProperties() {
    const { currentPage, properties, totalPages, onPageChange, totalCount } =
      this.props;

    return (
      <React.Fragment>
        <SelectionDetails
          label="property"
          selectedCount={this.props.selectedPropertyIds.length}
          totalCount={totalCount}
          onClearSelection={this.props.resetSelection}
          onSelectAll={this.props.toggleSelectAll}
        />
        <div className={classNames("d-flex flex-column", {
          'p-3 gap-2': this.props.edgeCrm,
        })}>
          {properties.map(property => (
            <MapListItem
              edgeCrm={this.props.edgeCrm}
              googleMapsApiKey={this.props.googleMapsApiKey}
              isSelected={
                this.props.selectedPropertyIds.indexOf(property.id) > -1
              }
              key={property.id}
              record={property}
              onClick={event => this.props.goToPropertyShow(event, property)}
              onMouseOver={() => this.throttledHover(property.id)}
              onSelectionToggle={() => this.props.toggleSelectProperty(property)}
            />
          ))}
          {properties.length < totalCount && (
            <div className="d-flex justify-content-center align-items-center">
              <UltimatePagination
                currentPage={currentPage}
                totalPages={totalPages}
                onChange={onPageChange}
              />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  ...state.properties,
  ...state.search.meta,

  allPropertiesIds: state.search.meta.propertyIds,
  edgeCrm: state.features.edgeCrm,
  googleMapsApiKey: state.ui.googleMapsApiKey,
  isFetchingProperties: state.search.isFetching,
  properties: state.search.properties,
  selectedPropertyIds: state.selectList.selectedPropertyIds,
  showMapList: state.ui.showMapList,
});

const mapDispatchToProps = {
  goToPropertyShow,
  toggleSelectProperty,
  toggleSelectAllPropertiesOnCurrentPage,

  resetSelection: resetSelectedProperties,
  toggleSelectAll: toggleSelectAllProperties,
  onPropertyHover: selectPropertyMarker,
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesMapList);
